let uuid = 0;


export default {
    beforeCreate() {
        this.uuid = uuid.toString();
        uuid += 1;
    },
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/mixins/uuid/index.js